import { AxiosResponse } from 'axios';
import vm from '@/main';

/**
 * Applies translation overrides to a single object based on a translations map.
 */
const changeSingleToTranslation = (single: any, translations: any = {}) => {
  if (single) {
    const singleFormatted: any = { ...single };
    Object.keys(translations).forEach((v) => {
      singleFormatted[v] = translations[v];
    });
    return singleFormatted;
  }

  return translations;
};

/**
 *  When the VueX store state's language is not English, modify the response body.
 */
export const translationResponseMiddleware = (response: AxiosResponse): AxiosResponse => {
  const app = vm();
  const language = app?.$store.state.language || 'en';

  if (language === 'en') {
    return response;
  }

  const translations = response.config.method?.toUpperCase() === 'GET'
    ? (response.data?.translations || [])[0]
    : response.data?.translations;

  const single = !Array.isArray(response.data?.data) ? response.data?.data : undefined;

  if (single && translations && response.config.method?.toUpperCase() === 'GET') {
    response.data.data = changeSingleToTranslation(single, translations);
  } else if (translations && ['PUT'].includes((response.config.method || '').toUpperCase()) && app) {
    app.$eventBus.$emit('set-language', language);
  }

  return response;
};
